import React from "react";

function answerText(question, answer) {
  if (question.type === "OPEN_TEXT") {
    return typeof answer === "string" && answer.trim() ? answer.trim() : "Sin respuesta";
  }
  const selectedIds = Array.isArray(answer)
    ? answer.map(Number)
    : answer === undefined || answer === null || answer === ""
      ? []
      : [Number(answer)];
  const labels = question.options
    .filter((option) => selectedIds.includes(option.id))
    .map((option) => option.label);
  return labels.length ? labels.join(", ") : "Sin respuesta";
}

export default function ReviewStep({
  questions,
  answers,
  error,
  loading,
  onBack,
  onSubmit,
}) {
  return (
    <div className="onboarding-card-inner">
      <div className="onboarding-step-head">
        <div>
          <h2>Revisa tu ficha</h2>
          <p>Confirma tus respuestas antes de enviarlas.</p>
        </div>
        <span className="onboarding-step-count">Paso 3 de 3</span>
      </div>

      {error && <p className="onboarding-error" role="alert">{error}</p>}

      <ul className="onboarding-answer-review" aria-label="Resumen de respuestas">
        {questions.map((question) => (
          <li key={question.id}>
            <strong>{question.prompt}</strong>
            <span>{answerText(question, answers[question.id])}</span>
          </li>
        ))}
      </ul>

      <div className="onboarding-button-row">
        <button
          className="onboarding-button onboarding-button--secondary"
          type="button"
          onClick={onBack}
          disabled={loading}
        >
          Volver a la ficha
        </button>
        <button
          className="onboarding-button onboarding-button--primary"
          type="button"
          onClick={onSubmit}
          disabled={loading}
        >
          {loading ? "Enviando…" : "Enviar ficha"}
        </button>
      </div>
    </div>
  );
}
